export default __webpack_public_path__ + "static/media/banner_home.93398bd0.png";